import { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { API } from '@src/lib/api_path'
import { HealthGoals } from '@src/routes/members/components/health-goals/health-goals'
import Checkup from '@src/data/checkup'
import { snakecaseKeys } from '@src/util/functions'
import WizardEditKgis from '@src/routes/members/components/wizard/components/health-goals/edit-kgis'
import { Divider } from '@src/elements/divider/divider'
import WizardAddGoal from '@src/routes/members/components/wizard/components/health-goals/add-goal'
import { Spacer } from '@src/elements/spacer/spacer'
import { DefaultValues } from '@src/util/default-values'
import { HealthGoalsService } from '@src/service/health-goal'
import { convertToYYYYMMDD } from '@src/util/date-format'

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    },
    goal () {
      return this.$store.state.goal
    },
    activities () {
      return this.$store.state.activities || []
    },
    exerciseTags () {
      return this.$store.state.completeExerciseTags || []
    }
  }
})
export class WizardHealthGoals extends HealthGoals {

  @Prop({ required: false, default: false })
  protected isReadonly: boolean

  protected checkup: Checkup

  constructor () {
    super()
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.CHECKUPS')}`
  }

  beforeMount () {
    return Promise.all([
      DefaultValues.loadPredefinedHealthGoals(this.$store),
      DefaultValues.loadExerciseTags(this.$store),
      DefaultValues.loadActivities(this.$store),
      this.loadGoalHistory(convertToYYYYMMDD(new Date()))
    ])
  }

  beforeDestroy () {
    if (!this.isReadonly) {
      return this.updateCheckup()
    }
  }

  render (h: CreateElement) {
    if (this.loading) {
      return
    }

    return <div class='key-health-goal'>
      <WizardAddGoal />
      <Spacer />
      <Divider />
      <Spacer />
      <WizardEditKgis goal={this.goal} saveOnChange={!this.isReadonly} />
    </div>
  }

  protected loadGoalHistory (date: string) {
    // load current health goal, if no health goal has been set and the wizard is not readonly
    const queryDate = (this.checkup.healthGoalAdded && this.checkup.healthGoalId) || this.isReadonly ? '' : date
    // load health goal by id
    const queryHealthGoalId = this.checkup.healthGoalId ? `${this.checkup.healthGoalId}` : ''

    if (queryDate !== '' || queryHealthGoalId !== '') {
      return new HealthGoalsService().getGoalHistory(this.$route.params.id, queryDate, queryHealthGoalId)
        .then(goal => {
          this.$store.dispatch('setGoal', goal)
        })
        .catch(() => {
          this.$store.dispatch('setGoal', null)
        })
        .finally(() => this.loading = false)
    } else {
      this.loading = false
    }
  }

  protected updateCheckup () {
    let checkup = new Checkup(this.checkup)
    checkup.healthGoalId = this.goal ? this.goal.id : null
    checkup.healthGoalAdded = true
    checkup.updateState()
    this.$store.dispatch('setCheckup', checkup)

    return this.apiClient.put(`${API.TRAINERS_API.CHECKUPS.replace('{memberId}', this.$route.params.id)}/${checkup.id}`, { checkup: snakecaseKeys(checkup) })
      .catch(err => console.error('Failed to update checkup, ', err))
  }
}
